// Język interfejsu: PL (domyślny, kod) albo EN (warstwa słownika, src/i18n/dom.ts).
//
// Wybór siedzi w ciasteczku `legia_lang` (rok, cała domena): czyta je front przy starcie,
// a backend przekazuje je Playwrightowi (PDF w języku osoby, która kliknęła — pdf.py).
// `?lang=en|pl` w adresie wygrywa i zapisuje się (link z maila, podgląd druku).
// Zalogowanemu język zapisuje się też na koncie (`app_user.lang`) — z niego maile.

export type Lang = 'pl' | 'en'

export const LANG_COOKIE = 'legia_lang'

function readCookie(): Lang | null {
  const m = document.cookie.match(/(?:^|;\s*)legia_lang=(pl|en)\b/)
  return m ? (m[1] as Lang) : null
}

function writeCookie(lang: Lang) {
  document.cookie = `${LANG_COOKIE}=${lang}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
}

function fromUrl(): Lang | null {
  const p = new URLSearchParams(window.location.search).get('lang')
  return p === 'en' || p === 'pl' ? p : null
}

const initial: Lang = (() => {
  if (typeof window === 'undefined') return 'pl'
  const u = fromUrl()
  if (u) { writeCookie(u); return u }
  return readCookie() ?? 'pl'
})()

/** Czy użytkownik kiedykolwiek wybrał język w tej przeglądarce (ciasteczko jest). */
export const langChosenHere = typeof document !== 'undefined' && readCookie() !== null

export const LANG: Lang = initial

/** Locale do Intl tam, gdzie wychodzą NAZWY (miesiące, dni). Liczby formatujemy
 * zawsze po polsku — warstwa EN sama przepisuje separatory (enNumbers). */
export const DATE_LOCALE = LANG === 'en' ? 'en-GB' : 'pl-PL'

/** Zmiana języka = przeładowanie strony (warstwa startuje przed Reactem, bez mignięcia PL). */
export function setLang(lang: Lang, opts: { persistAccount?: boolean } = {}) {
  writeCookie(lang)
  const done = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('lang')
    window.location.replace(url.toString())
  }
  if (opts.persistAccount === false) { done(); return }
  // Konto (maile w tym języku) — bez czekania na sukces, brak sesji = 401 bez znaczenia.
  fetch('/api/auth/me/lang', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ lang }),
  }).catch(() => undefined).finally(done)
}

/** Furtka na napisy dwuznaczne poza kontekstem (jednoliterowe skróty: „R" = remis albo
 * prawa noga, „P" = porażka albo prawa) — słownik jest globalny, więc takie miejsca
 * wybierają wersję same. Wynik warstwa EN zostawia w spokoju (nie ma go w słowniku). */
export const pick = (pl: string, en: string): string => (LANG === 'en' ? en : pl)
